const isDev = typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production';
export const API_BASE_URL = (
	(isDev ? process.env.REACT_APP_API_BASE_URL_DEV : process.env.REACT_APP_API_BASE_URL)
	|| process.env.REACT_APP_API_BASE_URL
	|| process.env.REACT_APP_API_BASE_URL_DEV
	|| ""
);
